export const sortByNewest = (items = [], field = 'createdAt') =>
    [...items].sort((a, b) => new Date(b?.[field] || 0) - new Date(a?.[field] || 0));
